// import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
// import img1 from "../../assets/Hire_Virtual_Assistant.png";
import HireVA from "../../assets/Best_Hire_Virtual_Assitant_In_Noida.jpg";
import React, { useState } from "react";

const VirtualAssistant = () => {

   const [formData, setFormData] = useState({ //
    name: '',
    companyName: '',
    email: '',
    phone: '',
    message: '',
  });

  // State for submission status and loading
  const [submissionStatus, setSubmissionStatus] = useState(''); //
  const [isSubmitting, setIsSubmitting] = useState(false); //

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => { //
    setFormData({ ...formData, [e.target.name]: e.target.value }); //
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => { //
    e.preventDefault(); // Prevent default form submission
    setIsSubmitting(true); // Disable button
    setSubmissionStatus('Submitting inquiry...'); // Set submitting status

    // Prepare data for the backend, mapping to FormSubmissionDto fields
    const dataToSend = {
      firstName: formData.name,
      lastName: '', // Not collected in this form, leave empty
      businessEmail: formData.email,
      phone: formData.phone,
      companyName: formData.companyName,
      interests: ['Virtual Assistant Inquiry'], // Specific interest for this page
      howDidYouFindUs: 'Website Virtual Assistant Page',
      subscribeNewsletter: false, // Default to false, no checkbox
      message: formData.message, // The detailed message
      courseOfInterest: '', // Not applicable for VA form
      collegeName: '',      // Not applicable for VA form
    };

    try {
      // Send data to your backend API
      const response = await fetch('/api/submit-form', { //
        method: 'POST', //
        headers: { //
          'Content-Type': 'application/json', //
        },
        body: JSON.stringify(dataToSend), //
      });

      if (response.ok) {
        setSubmissionStatus('Thank you for your inquiry! We will get back to you soon.'); //
        // Clear the form after successful submission
        setFormData({ //
          name: '',
          companyName: '',
          email: '',
          phone: '',
          message: '',
        });
      } else {
        const errorText = await response.text(); //
        setSubmissionStatus(`Submission failed: ${response.status} - ${errorText}`); //
      }
    } catch (error) {
      console.error('Error submitting form:', error); //
      setSubmissionStatus('An error occurred during submission.'); //
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };


  const serviceCategories = [
    {
      icon: "📚", // Books/Learning for Admin
      title: "Administrative Support",
      description: "Email management, scheduling, data entry, document preparation, travel arrangements, and general office support.",
      
    },
    {
      icon: "📣", // Megaphone for Marketing
      title: "Digital Marketing Assistance",
      description: "Social media management, content scheduling, email campaign setup, basic SEO tasks, and online ad support.",
    },
    {
      icon: "📝", // Memo/List for Content
      title: "Content & Creative Tasks",
      description: "Blog post formatting, research for articles, basic graphic design (Canva), video transcription, and proofreading.",
    },
    {
      icon: "📞", // Phone for Customer Service
      title: "Customer Support & CRM",
      description: "Handling customer inquiries, managing CRM systems, responding to feedback, and providing front-line support.",
    },
    {
      icon: "📊", // Bar chart for Data
      title: "Research & Data Management",
      description: "Market research, competitor analysis, lead generation, data compilation, and database organization.",
    },
    {
      icon: "🤝", // Handshake for Sales
      title: "Sales Support",
      description: "Lead qualification, outreach coordination, CRM updates, appointment setting, and sales presentation preparation.",
    },
  ];

  const hiringProcessSteps = [
  {
    step: "1",
    title: "PERSONAL VA",
    description: "By managing schedules, streamlining work, and increasing productivity, a personal virtual assistant frees you up to concentrate on your primary duties and objectives.",
    image: "https://nvassistant.com/Assets/allimages/virtualAssistance/NADEZHDA_VENTURES_%20virtuaAssitant_hr.png",
    readMoreLink: "https://nvassistant.com/personalvirtualassistance.html" // Example link for Personal VA
  },
  {
    step: "2",
    title: "RECRUIT_HR VA",
    description: "For companies of all sizes, the RECRUIT_HR virtual assistant improves candidate management, expedites the hiring process, and boosts overall HR effectiveness.",
    image: "https://nvassistant.com/Assets/allimages/virtualAssistance/nadezhdaventuresrecruit_hr.png",
    readMoreLink: "https://nvassistant.com/Virtual.html" // Example link for RECRUIT_HR VA
  },
  {
    step: "3",
    title: "REAL ESTATE VA",
    description: "A real estate virtual assistant improves productivity and efficiency in property administration and transactions by streamlining processes, managing listings, and assisting agents.",
    image: "https://nvassistant.com/Assets/allimages/virtualAssistance/nadezhdaventuresvirtual_assistant.png",
    readMoreLink: "https://nvassistant.com/realstatevirtualassistant.html" // Example link for REAL ESTATE VA
  },
  {
    step: "4",
    title: "Seamless Onboarding",
    description: "Nadezhda Ventures streamlines the onboarding process, welcoming new employees and providing essential training for quick productivity. Our training programs emphasize skill enhancement and continuous professional development.",
    image: "https://nvassistant.com/Assets/allimages/virtualAssistance/NADEZHDA_VENTURES_HIRE_personalVIRTUAL_ASSISTANT.png",
    readMoreLink: "https://nvassistant.com/hrAndRecruitment.html" // Example link for Seamless Onboarding
  },
  {
    step: "5",
    title: "Performance Management",
    description: "Nadezhda Ventures performance management systems help clients assess and enhance employee performance. By implementing effective evaluation processes and offering performance. improvement strategies.",
    // Assuming 'img1' is a defined variable with an image path
    image: "https://nvassistant.com/Assets/allimages/virtualAssistance/nadezhda_ventures_microsoftoffice.png", // Replaced 'img1' with a placeholder
    readMoreLink: "https://nvassistant.com/hrAndRecruitment.html" // Example link for Performance Management
  }
];


  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>Hire a Virtual Assistant in Noida | Expert Virtual Staffing Solutions</title>
        <meta
          name="description"
          content="Hire pre-vetted Virtual Assistants in Noida for administrative, marketing, creative, and customer support. Boost productivity and save costs with our reliable virtual staffing solutions."
        />
        <meta
          name="keywords"
          content="Hire Virtual Assistant Noida, Virtual Staffing solutions, Remote Assistant services, outsource administrative tasks, virtual marketing assistant, virtual customer support, hire VA India, remote executive assistant"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden text-white h-[450px] bg-gray-900 flex items-center">
        <img
          src={HireVA}
          alt="Hire Virtual Assistant Background"
          className="absolute inset-0 w-full h-full object-cover z-0 opacity-80"
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 flex flex-col md:flex-row items-center md:items-start">
          <div className="md:w-full text-center pt-32">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-extrabold leading-tight"
            >
              Get <span className="text-orange-400">Hire a Virtual Assistant</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="mt-6 text-lg md:text-xl text-gray-200 max-w-3xl mx-auto"
            >
             Nadezhda Ventures Pvt Ltd offers customised virtual staffing solutions that put you in touch with qualified experts to boost productivity and grow your company with ease.


            </motion.p>

            {/* <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="mt-8 bg-orange-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 ease-in-out text-lg"
            >
              Get Your Free Consultation
            </motion.button> */}
          </div>
        </div>
      </section>

      {/* Why Hire a Virtual Assistant Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-blue-900">Why Choose a Virtual Assistant?</h2>
          <p className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
            Virtual Assistants are key to scaling your operations without the overheads. They provide flexible, cost-effective support, allowing you to focus on core business growth.
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-10">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-teal-700 mb-3">Cost-Effective</h3>
              <p className="text-gray-600">Save on office space, benefits, and equipment costs.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-teal-700 mb-3">Increased Productivity</h3>
              <p className="text-gray-600">Delegate routine tasks and focus on strategic initiatives.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-teal-700 mb-3">Access to Diverse Skills</h3>
              <p className="text-gray-600">Tap into a pool of VAs with specialized expertise as needed.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-teal-700 mb-3">Flexibility & Scalability</h3>
              <p className="text-gray-600">Scale support up or down based on your business demands.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-teal-700 mb-3">Time Zone Advantage</h3>
              <p className="text-gray-600">Leverage VAs in different time zones for round-the-clock operations.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <h3 className="font-semibold text-xl text-teal-700 mb-3">Reduced Overhead</h3>
              <p className="text-gray-600">Minimize recruitment time and administrative burden.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Offered by Our Virtual Assistants */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-blue-900">Services Our Virtual Assistants Offer</h2>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto text-center">
            Our Virtual Assistants are proficient in a wide range of tasks, ready to support various facets of your business.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {serviceCategories.map((service, index) => (
              <motion.div
                key={index}
                className="bg-teal-50 p-6 rounded-lg shadow-md flex items-start space-x-4"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="text-4xl flex-shrink-0">{service.icon}</div>
                <div>
                  <h3 className="font-semibold text-xl text-teal-800 mb-2">{service.title}</h3>
                  <p className="text-gray-700">{service.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Seamless Hiring Process */}
<section className="py-20 bg-gray-100">
  <div className="max-w-7xl mx-auto px-4 text-center">
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-4xl font-bold mb-4 text-blue-900"
    >
      Our Seamless Hiring Process
    </motion.h2>
    <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-16">
      From consultation to onboarding, our hiring process is streamlined for speed and quality.
    </p>

    <div className="space-y-20">
      {hiringProcessSteps.map((step, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.2 }}
          viewport={{ once: true, amount: 0.4 }}
          className={`flex flex-col md:flex-row items-center gap-10 ${
            index % 2 === 1 ? "md:flex-row-reverse" : ""
          }`}
        >
          {/* Image */}
          <div className="md:w-1/2 md:pl-40">
            <img
              src={step.image}
              alt={step.title}
              className="w-[200px] h-[200px] rounded-xl shadow-lg "
            />
          </div>

          {/* Text */}
          <div className="md:w-1/2 text-left">
            <div className="flex items-center mb-4">
              <span className="text-white bg-blue-800 w-10 h-10 flex items-center justify-center rounded-full text-lg font-bold shadow">
                {step.step}
              </span>
              <h3 className="ml-4 text-2xl font-semibold text-blue-800">
                {step.title}
              </h3>
            </div>
            <p className="text-gray-700 text-lg">
              {step.description}
              {step.readMoreLink && ( // Conditionally render the link if readMoreLink exists
                <a
                  href={step.readMoreLink}
                  target="_blank" // Opens in a new tab
                  rel="noopener noreferrer" // Security best practice for target="_blank"
                  className="text-blue-600 hover:text-blue-800 font-semibold ml-2"
                >
                  Read More
                </a>
              )}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
</section>


      {/* Call to Action - Ready to Hire?
      <section className="py-16 bg-teal-600 text-white text-center">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Workflow?</h2>
          <p className="text-xl mb-8">
            Let us help you find the perfect Virtual Assistant to propel your business forward.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-white text-teal-800 hover:bg-gray-100 font-bold py-3 px-10 rounded-full shadow-lg transition duration-300 ease-in-out text-lg"
          >
            Request a Free Consultation Now
          </motion.button>
        </div>
      </section> */}

        {/* Enquiry Form Section - Connected to backend */}
      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center md:text-left">Frequently Asked Questions about Virtual Staffing</h2>
          {/* FAQ Content - You might want to add more specific FAQs here for hiring */}
          <div className="space-y-4">
            {[
              {
                title: "What is a Virtual Assistant and how can they help my business?",
                answer: "A Virtual Assistant (VA) is a highly skilled independent professional who provides administrative, technical, or creative assistance remotely. They can help your business by taking over routine tasks, managing projects, handling customer inquiries, providing marketing support, and much more, freeing up your time to focus on core business activities.",
              },
              {
                title: "How do you ensure the quality and reliability of your Virtual Assistants?",
                answer: "We employ a rigorous vetting process that includes skill assessments, background checks, interviews, and reference checks. Our VAs are chosen for their expertise, professionalism, and proven ability to work independently and efficiently. We also offer ongoing support and performance monitoring.",
              },
              {
                title: "What types of businesses commonly hire Virtual Assistants?",
                answer: "Small to medium-sized businesses (SMBs), startups, entrepreneurs, busy executives, and even large corporations often hire VAs. They are particularly beneficial for businesses looking to reduce overheads, scale operations flexibly, and gain specialized support without hiring full-time employees.",
              },
              {
                title: "How quickly can I hire a Virtual Assistant through your service?",
                answer: "Once we understand your specific needs, our matching process is highly efficient. You can expect to interview pre-vetted candidates within a few days, and typically have a Virtual Assistant ready to start within 1-2 weeks, depending on the complexity of your requirements.",
              },
              {
                title: "What is the typical cost of hiring a Virtual Assistant?",
                answer: "Costs vary depending on the VA's skill set, experience, and the number of hours required. We offer flexible pricing models (hourly, part-time, full-time packages) designed to provide significant cost savings compared to traditional in-house hiring. Contact us for a custom quote based on your needs.",
              },
              {
                title: "Can I choose my own Virtual Assistant?",
                answer: "Absolutely. We provide you with a shortlist of carefully matched Virtual Assistants. You'll have the opportunity to interview them directly to ensure they are the perfect fit for your team and specific requirements.",
              },
            ].map((section, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {section.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{section.answer}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Form for Hiring - Modified to connect to backend */}
        <div className="md:col-span-1 pt-20">
          <div className="bg-blue-300 rounded-lg p-6 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-center text-blue-800">
              Find Your Perfect VA Today
            </h3>
            <p className="text-center text-gray-600 mb-6">
              Tell us about your needs and we'll help you find the right Virtual Assistant.
            </p>
            <form className="space-y-4" onSubmit={handleSubmit}> {/* Added onSubmit */}
              <input
                type="text"
                name="name" // Added name
                placeholder="Your Name"
                value={formData.name} // Added value
                onChange={handleChange} // Added onChange
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
                required
              />
              <input
                type="text"
                name="companyName" // Added name
                placeholder="Company Name (Optional)"
                value={formData.companyName} // Added value
                onChange={handleChange} // Added onChange
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
              <input
                type="email"
                name="email" // Added name
                placeholder="Your Business Email"
                value={formData.email} // Added value
                onChange={handleChange} // Added onChange
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
                required
              />
              <input
                type="tel"
                name="phone" // Added name
                placeholder="Phone Number"
                value={formData.phone} // Added value
                onChange={handleChange} // Added onChange
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
                required
              />
              <textarea
                name="message" // Added name
                placeholder="Tell us about your Virtual Assistant needs (e.g., tasks, hours, specific skills)"
                rows={4}
                value={formData.message} // Added value
                onChange={handleChange} // Added onChange
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
                required
              ></textarea>
              <button
                type="submit"
                className={`w-full py-3 rounded-md font-semibold transition duration-300 ease-in-out shadow-md hover:shadow-lg
                  ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-800 hover:bg-blue-700 text-white'}`}
                disabled={isSubmitting} // Disable button during submission
              >
                {isSubmitting ? 'Submitting Inquiry...' : 'SUBMIT INQUIRY'} {/* Dynamic button text */}
              </button>
              {submissionStatus && ( // Display submission status
                <p className={`mt-3 text-center text-sm ${submissionStatus.includes('failed') || submissionStatus.includes('error') ? 'text-red-600' : 'text-green-800'}`}>
                  {submissionStatus}
                </p>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VirtualAssistant;